// extracted by mini-css-extract-plugin
module.exports = {"dark":"SubscribeForm-module--dark--1s2ki","container":"SubscribeForm-module--container--xzqel"};